import React from 'react';
import PortableTextContent from './PortableTextContent';
import { isPortableText } from '../../utils/portableTextUtils';
import '../../css/common/RichText.css';

/**
 * Renders CMS rich text (portable text blocks) with fallback for legacy plain strings.
 */
const RichText = ({ value, className = '' }) => {
  if (value == null || value === '') return null;

  if (isPortableText(value)) {
    return <PortableTextContent value={value} className={className} />;
  }

  if (typeof value === 'string') {
    return (
      <div className={`richtext-content ${className}`.trim()}>
        <p className="richtext-p">{value}</p>
      </div>
    );
  }

  if (Array.isArray(value) && value.length > 0 && typeof value[0] === 'string') {
    return (
      <div className={`richtext-content ${className}`.trim()}>
        {value.map((paragraph, index) => (
          <p key={index} className="richtext-p">
            {paragraph}
          </p>
        ))}
      </div>
    );
  }

  return null;
};

export default RichText;
